import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesLinksByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesLinksByIdPatchAsyncSlice } from './patch';

export const coreInitiativesLinksByIdReducers = combineReducers({
	delete: coreInitiativesLinksByIdDeleteAsyncSlice.asyncReducers,
	patch: coreInitiativesLinksByIdPatchAsyncSlice.asyncReducers
});

export const coreInitiativesLinksByIdWatchers = combineAllWatchers([
	coreInitiativesLinksByIdDeleteAsyncSlice.asyncWatchers,
	coreInitiativesLinksByIdPatchAsyncSlice.asyncWatchers
]);
